exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".NotificationsPage-2125bb0c{max-width:800px;margin:60px auto}a.markAsRead-6ceb64c6,a.markAsRead-6ceb64c6:hover,a.markAsRead-6ceb64c6:visited,a.markAsRead-6ceb64c6:active{color:#757575;text-decoration:none}@media screen and (max-width: 800px){.NotificationsPage-2125bb0c{margin:0 auto}.NotificationsPage-2125bb0c h1{margin:0 0;font-size:15px;line-height:1.5;text-align:center;font-weight:bold;padding:15px 0;border-bottom:1px solid #E0E0E0}}\n", ""]);

// Exports
exports.locals = {
	"NotificationsPage": "NotificationsPage-2125bb0c",
	"markAsRead": "markAsRead-6ceb64c6"
};